module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-21.b4fa0103.png";